import React from 'react';
import { SearchZoomOut, SearchZoomIn } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { useZoom } from '../context/ZoomContext';

interface FloatingControlsProps {
    showControls: boolean;
    isSidebarExpanded: boolean;
    rightSidebarWidth: number;
}

export const FloatingControls: React.FC<FloatingControlsProps> = ({
    showControls,
    isSidebarExpanded,
    rightSidebarWidth,
}) => {
    const { zoom, handleZoomOut, handleZoomIn } = useZoom();

    return (
        <div
            className={`pointer-events-none fixed bottom-6 z-10 flex items-center justify-center gap-6 transition-all duration-300 ${
                showControls ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
                left: isSidebarExpanded ? '304px' : '24px',
                right: rightSidebarWidth > 0 ? `${rightSidebarWidth}px` : '24px',
            }}
        >
            <div
                className={`flex items-center gap-2 rounded-full border border-border/50 bg-card/80 px-4 py-2 shadow-xl backdrop-blur-md ${
                    showControls ? 'pointer-events-auto' : ''
                }`}
            >
                <Button variant="ghost" size="icon" className="size-8" onClick={handleZoomOut}>
                    <SearchZoomOut className="size-4" />
                </Button>

                <span className="min-w-[50px] text-center text-sm font-medium">
                    {Math.round(zoom * 100)}%
                </span>

                <Button variant="ghost" size="icon" className="size-8" onClick={handleZoomIn}>
                    <SearchZoomIn className="size-4" />
                </Button>
            </div>
        </div>
    );
};
